import { createCRUDSlice } from "../crudSliceFactory";

const { actions, reducer, selectors } = createCRUDSlice("customerRfqs", "/customer-rfqs");

export const {
  fetchAll: fetchCustomerRfqs,
  fetchOne: fetchOneCustomerRfqs,
  createOne: createCustomerRfqs,
  updateOne: updateCustomerRfqs,
  deleteOne: deleteCustomerRfqs,
  clearSelected,
  clearError,
} = actions;

export const {
  selectList,
  selectSelected,
  selectLoading,
  selectSubmitting,
  selectError,
  selectPagination,
} = selectors;

export default reducer;
